/**
 * Created by tdunham on 7/7/2017.
 */

import {Injectable}                         from "@angular/core";
import {HttpClient, HttpHeaders}            from "@angular/common/http";

import {AngularQuery}                       from "../query/angularquery";
import {Source}                             from './source';

import {map}                                from "rxjs/operators";
import {Observable}                         from "rxjs";


@Injectable()
export class SourceService {

	/**
	 * Initialize the object.
	 *
	 * @param {HttpClient} http  Connection to HTTP.
	 */
	constructor(protected http: HttpClient) {}


	/**
	 * Delete the source associated with the specified ID number.
	 *
	 * @param {number} id  The ID of the Source to delete.
	 * @returns {Observable<Boolean>} Whether the delete was successful or not.
	 */
	deleteSource(id:number): Observable<Boolean> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_SOURCE, id.toString());
		query.useParams(false);
		query.useCacheBuster(false);
		let url:string = query.getUrl();

		return this.http
			.delete<Boolean>(url)
			.pipe(
				map(() => true)
			);

	}


	/**
	 * Get the Source object specified by the provided Angular ReST API ID.
	 *
	 * @param id       An Angular ReST API ID value from the "source" table.
	 * @returns {Observable<Source>}  An Observable<Source> object or error.
	 */
	getSource(id: number): Observable<Source> {

		let query:AngularQuery = new AngularQuery();
		query.setPerPage(1);
		query.setEndpoint(AngularQuery.ENDPOINT_SOURCE, id.toString());
		let url = query.getUrl();
		return this.http
			.get<Source>(url);

	}


	/**
	 * Save the provided source information.
	 *
	 * @param {string} url    The URL to post to.
	 * @param {string} json   The data as a JSON string.
	 * @return {Observable<Source>}  The saved Source data echoed back.
	 */
	save(url: string, json: string): Observable<Source> {

		// Warn them that JSON is coming.
		let headers = new HttpHeaders().append('Content-Type', 'application/json');
		return this.http
			.post<Source>(url, json, { headers: headers });

	}


	/**
	 * Search for the source and return an Observable.
	 *
	 * @param {string} name  The name of the source being searched for.
	 * @param {boolean} anywhere  If true, the search is bracked by '%'; if false, the '%' is only at the end.
	 * @returns {Observable<Source[]>}  An Observable with Sources found.
	 */
	search(name: string, anywhere:boolean): Observable<Source[]> {

		if (2 >= name.length) {
			return Observable.of([]);
		}

		let query: AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_SOURCE);        // Select the table to search.
		query.setPerPage(10);                                   // Limit results to 10 entries.
		query.addParameter('field', 'name');                    // Do a search of the 'name' field.

		if (anywhere) {

			query.addParameter('search', '%' + name + '%');

		} else {

			query.addParameter('search', name + '%');

		}

		query.addParameter('order_field', 'name');
		query.addParameter('sort_order', 'ASC');
		let url = query.getUrl();
		return this.http
			.get<Source[]>(url);

	}

}


// WEBPACK FOOTER //
// ./src/app/services/source/source.service.ts